<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-apps
      </v-icon> Product List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-col
        class="text-right"
      >
        <v-btn
          color="#FF3700"
          @click="createProduct()"
        >
          <v-icon
            left
            dark
          >
            mdi-plus
          </v-icon>
          Product
        </v-btn>
      </v-col>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              dense
              label="Search"
              append-icon="mdi-magnify"
              outlined
            />
          </v-col>
          <v-spacer />
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items=" productList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.name }}</td>
            <td>{{ item.description }}</td>
            <td>
              {{ item.product_tier | productUpdate }}
            </td>
            <td>
              <font
                :color="getColor(item.active)"
                class="font-my-style"
              >
                {{ item.active | statusUpdate }}
              </font>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="productPrice(item.id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
    <create-product
      v-if="showForm"
      @closed="showForm=false"
      @get-product-list="getProductList()"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import createProduct from 'src/views/dashboard/payments/createProduct.vue';

  export default {
    name: 'Products',
    components: {
      'centre-spinner': spinner,
      'create-product': createProduct,
    },
    filters: {
      statusUpdate (active) {
        if (active === true) {
          return 'Active*';
        } else {
          return 'InActive';
        }
      },
      productUpdate (product) {
        if (product === 'advanced') {
          return 'Advanced';
        } else if (product === 'basic') {
          return 'Basic';
        } else {
          return 'Enterprise';
        }
      },
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Name', align: 'start', value: 'name' },
          { text: 'Discription', value: 'description' },
          { text: 'Product Tier', value: 'product_tier' },
          { text: 'Status', value: 'status' },
          { text: 'Prices', value: 'prices' },
        ],
        showForm: false,
      };
    },
    computed: {
      productList () {
        return this.$store.getters['payments/getProductsList'];
      },
    },
    async mounted () {
      await this.getProductList();
    },
    methods: {
      async getProductList () {
        this.loading = true;
        await this.$store.dispatch('payments/fetchProductsList');
        this.loading = false;
      },
      getColor (status) {
        if (status === true) {
          return '#2E7D32';
        } else {
          return '#C62828';
        }
      },
      createProduct () {
        this.showForm = true;
      },
      productPrice (productid) {
        this.$router.push(`products/${productid}`);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.font-my-style {
  font-weight: bold;
}
.v-data-table { background-color: #ECEFF1; }
</style>
